import React from 'react';

// Allow user to navigate previous, next, or complete their questionnaire in the expected way
export default class ScreenNav extends React.Component {
    render() {
        return (
            <div style={{ paddingBottom: '1em' }}>
                <button
                    key="snb1"
                    type="button"
                    onClick={() => {
                        if (this.props.questionnaire.mouseBack) this.props.previous();
                        this.props.questionnaire.mouseBack = false;
                    }}
                    onMouseDown={() => {
                        this.props.questionnaire.mouseBack = true;
                    }}
                    disabled={!this.props.previousAble}
                    className="navigation-button"
                >
                    <span aria-hidden="true">◀ </span>Previous Page
                </button>
                &nbsp;
                <button
                    key="snb2"
                    type="button"
                    onClick={() => {
                        if (this.props.questionnaire.mouseNext && this.props.nextAble) this.props.next();
                        this.props.questionnaire.mouseNext = false;
                    }}
                    onMouseDown={() => {
                        this.props.questionnaire.mouseNext = true;
                    }}
                    className="navigation-button"
                >
                    Next Page<span aria-hidden="true"> ▶</span>
                </button>
            </div>
        );
    }
}
